import Vue from 'vue'
import Router from 'vue-router'
import landingPage from '../components/availabilitySearch/landingPage.vue';
import availabilitySearch from '../components/availabilitySearch/availabilitySearch.vue';
import guestInfo from '../components/guestInfoDetails/guestInfoDetails.vue';
import paymentInfo from '../components/paymentInfoDetails/paymentInfoDetails.vue';
import ThankYouPage from '../components/ThankYouPage/ThankYouPage.vue';
import UnitDetails from '../components/unitDetails/unitDetails.vue';
import unitDetailPage from '../components/availabilitySearch/unitDetailPage.vue';
import termsAndConditions from '../components/termsAndConditions/termsAndConditions.vue';



import googleMaps from '../components/googleMapsComponent/googleMapsComponent.vue';


// import vueSlider from '../components/sliderComponent/sliderComponent.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'landingPage',
      component: landingPage,
      props: {}
    },
    {
      path: '/availabilitySearch',
      name: 'availabilitySearch',
      component: availabilitySearch,
      props: {}
    },
    {
      path: '/unitDetail/:UnitId/:PropertyId/',
      name: 'unitDetailPage',
      component: unitDetailPage,
      props: {}
    },
    // {
    //   path: '/guestInfoDetails/:ReservationId/',
    //   name: 'guestInfoDetails',
    //   component: guestInfoDetails,
    //   props: {}
    // },
    {
      path: '/guestInfo/:confirmationNumber/:email?',
      name: 'guestInfo',
      component: guestInfo,
      props: {}
    },
    {
      path: '/paymentInfo/:confirmationNumber/:email?',
      name: 'paymentInfo',
      component: paymentInfo,
      props: {}
    },
    {
      path: '/termsAndConditions/:confirmationNumber',
      name: 'termsAndConditions',
      component: termsAndConditions,
      props: {}
    },
    
    
    // {
    //   path: '/paymentInfoDetails/:StatusName/:ReservationId/:confirmationNumber',
    //   // path: "/bookingEnginedetail/:beId",
    //   name: 'paymentInfoDetails',
    //   component: paymentInfoDetails,
    //   props: {}
    // },
    {
      path: '/ThankYouPage/:confirmationNumber/:email?',
      name: 'ThankYouPage',
      component: ThankYouPage,
      props: {}
    },
    // {
    //   path: '/termsAndConditions/:confirmationNumber',
    //   name: 'termsAndConditions',
    //   component: termsAndConditions,
    //   props: {}
    // },

    // {
    //   path: '/unitDetails/:UnitId/:PropertyId',
    //   name: 'UnitDetails',
    //   component: UnitDetails,
    //   props: {}
    // },

    // {
    //   path: '/googleMaps',
    //   name: 'googleMaps',
    //   component: googleMaps,
    //   props: {}
    // }


    // {
    //   path: '/vueSlider',
    //   name: 'vueSlider',
    //   component: vueSlider,
    //   props: {}
    // },
 
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js